import { enqueueSnackbar } from 'actions';
import { DownloadFile, UploadFile } from 'actions/sessionActions.js';

import {
	GetActivitiesRequest,
	GetActivityRequest,
	GetActivityElementsRequest,
	GetTaskRequest,
	GetElementTaskRequest,
	FullExportRequest,
	ProcessElementCreationRequest,
	ProcessImportExportRequest,
	PostElementTaskCommentRequest,
	SaveElementTaskDetailsRequest,
	ChangeColumnVisibilityRequest,
	GetVisibleColumnsRequest,
	InitializeDatatableColumnsRequest
} from '../requests/ActivityViewRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_ACTIVITIES = 'GET_ACTIVITIES';
export const GET_ACTIVITY = 'GET_ACTIVITY';
export const GET_ACTIVITY_ELEMENTS = 'GET_ACTIVITY_ELEMENTS';
export const GET_TASK = 'GET_TASK';
export const GET_ELEMENT_TASK = 'GET_ELEMENT_TASK';
export const GET_VISIBLE_COLUMNS = 'GET_VISIBLE_COLUMNS';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onGetActivities = (value) => ({
	type: GET_ACTIVITIES,
	activities: value
});

const onGetActivity = (value) => ({
	type: GET_ACTIVITY,
	activity: value
});

const onGetActivityElements = (value) => ({
	type: GET_ACTIVITY_ELEMENTS,
	activityElements: value
});

const onGetTask = (value) => ({
	type: GET_TASK,
	task: value
});

const onGetElementTask = (value) => ({
	type: GET_ELEMENT_TASK,
	elementTask: value
});

const onGetVisibleColumns = (value) => ({
	type: GET_VISIBLE_COLUMNS,
	visibleColumns: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const GetActivities = () => async (dispatch) => {
	await GetActivitiesRequest().then(response => {
		dispatch(onGetActivities(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const InitializeDatatableColumns = (initializeColumns) => async (dispatch) => {
	await InitializeDatatableColumnsRequest(initializeColumns).then(response => {
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetVisibleColumns = (userId, datatableId, activity) => async (dispatch) => {
	await GetVisibleColumnsRequest(userId, datatableId).then(response => {
		const visibleColumns = response.data;
		dispatch(onGetVisibleColumns(response.data));
		if (visibleColumns.length <= 0 && userId) {
			const columns = activity.tasks.slice(0, 10);
			const initializeColumns = [];
			columns.map((item) => {
				initializeColumns.push({ userId, datatableId, columnId: `${item.activityTaskId}`, action: 'add' });
				return true;
			});
			dispatch(InitializeDatatableColumns(initializeColumns));
		}
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetActivity = (userId, activityId) => async (dispatch) => {
	await GetActivityRequest(activityId).then(response => {
		dispatch(onGetActivity(response.data));
		dispatch(GetVisibleColumns(userId, `ActivityDataTable_${activityId}`, response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetActivityElements = (activityId) => async (dispatch) => {
	await GetActivityElementsRequest(activityId).then(response => {
		dispatch(onGetActivityElements(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTask = (elementTaskId) => async (dispatch) => {
	await GetTaskRequest(elementTaskId).then(response => {
		dispatch(onGetTask(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetElementTask = (elementTaskId) => async (dispatch) => {
	await GetElementTaskRequest(elementTaskId).then(response => {
		dispatch(onGetElementTask(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const FullExport = () => async (dispatch) => {
	await FullExportRequest().then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetElementCreationTemplate = (fileLocation) => async (dispatch) => {
	dispatch(DownloadFile(fileLocation));
};

export const ProcessElementCreation = (userId, fileLocation) => async (dispatch) => {
	await ProcessElementCreationRequest(userId, fileLocation).then(response => {
		dispatch(enqueueSnackbar({ message: 'Files uploaded with success!', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadElementCreation = (userId, file) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(ProcessElementCreation(userId, response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ProcessImportExport = (userId, fileLocation) => async (dispatch) => {
	await ProcessImportExportRequest(userId, fileLocation).then(response => {
		dispatch(enqueueSnackbar({ message: 'Files uploaded with success!', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadImportExport = (userId, file) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(ProcessImportExport(userId, response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const PostElementTaskComment = (elementTaskId, userId, comment) => async (dispatch) => {
	await PostElementTaskCommentRequest(elementTaskId, userId, comment).then(response => {
		dispatch(GetElementTask(elementTaskId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SaveElementTaskDetails = (details) => async (dispatch) => {
	await SaveElementTaskDetailsRequest(details).then(response => {
		dispatch(enqueueSnackbar({ message: 'Details saved sucessfuly', options: { variant: 'success' } }));
		dispatch(GetElementTask(details.elementTaskId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ChangeColumnVisibility = (changeColumn) => async (dispatch) => {
	await ChangeColumnVisibilityRequest(changeColumn).then(response => {
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
